export const en = {
  'enum.apiKeyScope.members:read': 'Members',
  'enum.apiKeyScope.payments:read': 'Payments',
  'enum.apiKeyScope.visits:read': 'Visits',
  'enum.apiKeyScope.classes:read': 'Classes',

  'enum.apiKeyStatus.ACTIVE': 'Active',
  'enum.apiKeyStatus.EXPIRED': 'Expired',
  'enum.apiKeyStatus.REVOKED': 'Revoked',

  'enum.webhookEvent.member.created': 'New member',
  'enum.webhookEvent.membership.activated': 'Membership activated',
  'enum.webhookEvent.membership.expired': 'Membership expired',
  'enum.webhookEvent.payment.succeeded': 'Payment received',
  'enum.webhookEvent.payment.refunded': 'Payment refunded',
  'enum.webhookEvent.visit.recorded': 'Visit recorded',
  'enum.webhookEvent.ping': 'Test event',

  'enum.webhookDeliveryStatus.PENDING': 'Waiting',
  'enum.webhookDeliveryStatus.SUCCEEDED': 'Delivered',
  'enum.webhookDeliveryStatus.FAILED': 'Failed',
  'enum.webhookDeliveryStatus.SKIPPED': 'Skipped',

  'enum.webhookDeliveryError.TIMEOUT': 'No answer in time',
  'enum.webhookDeliveryError.CONNECTION_FAILED': 'Could not connect',
  'enum.webhookDeliveryError.TLS_FAILED': 'Secure connection failed',
  'enum.webhookDeliveryError.PRIVATE_ADDRESS': 'Address is not public',
  'enum.webhookDeliveryError.UNRESOLVABLE': 'Address not found',
  'enum.webhookDeliveryError.INVALID_URL': 'Address is not valid',
  'enum.webhookDeliveryError.ENDPOINT_DISABLED': 'Endpoint was switched off',
  'enum.webhookDeliveryError.SECRET_UNREADABLE': 'Bulk could not read the signing secret; nothing was sent',

  'apiAccess.keys.title': 'API keys',
  'apiAccess.keys.description': 'Read-only keys for your own tools, such as an accountant’s software or a lobby display. A key can never change anything in Bulk.',
  'apiAccess.keys.baseUrl': 'Address your tools call',
  'apiAccess.keys.baseUrlHint': 'Send the key in the Authorization: Bearer … header. It works only at this gym’s address. The reference is at {docs}.',
  'apiAccess.keys.new': 'New key',
  'apiAccess.keys.empty': 'No API keys yet',
  'apiAccess.keys.emptyHint': 'Make a key when one of your tools needs to read members, payments, visits or classes.',
  'apiAccess.keys.key': 'Key',
  'apiAccess.keys.reads': 'Can read',
  'apiAccess.keys.allowedFrom': 'Allowed from',
  'apiAccess.keys.anyAddress': 'Any address',
  'apiAccess.keys.lastUsed': 'Last used',
  'apiAccess.keys.expires': 'Expires',
  'apiAccess.keys.createdBy': 'Created by',
  'apiAccess.keys.revoke': 'Revoke',
  'apiAccess.keys.revokeNamed': 'Revoke the key “{name}”',
  'apiAccess.keys.revokeTitle': 'Revoke “{name}”?',
  'apiAccess.keys.revokeHint': 'Any tool using this key stops working at once. This cannot be undone; make a new key if you need one again.',
  'apiAccess.keys.revoked': 'Key revoked',

  'apiAccess.keyForm.title': 'New API key',
  'apiAccess.keyForm.description': 'A key only reads. Choose what it may read, where it may be used from and when it stops working.',
  'apiAccess.keyForm.namePlaceholder': 'Accountant export',
  'apiAccess.keyForm.nameHint': 'What the key is for, so you can tell your keys apart later.',
  'apiAccess.keyForm.nameRequired': 'Give the key a name',
  'apiAccess.keyForm.scopes': 'May read',
  'apiAccess.keyForm.scopesRequired': 'Choose at least one',
  'apiAccess.keyForm.scopeHint.members': 'Names, member numbers, contact details and status.',
  'apiAccess.keyForm.scopeHint.payments': 'Payments and refunds.',
  'apiAccess.keyForm.scopeHint.visits': 'Entries at the doors and the front desk.',
  'apiAccess.keyForm.scopeHint.classes': 'Classes and their scheduled sessions.',
  'apiAccess.keyForm.addresses': 'Allowed addresses',
  'apiAccess.keyForm.addressesHint': 'One per line, or separated by commas. Leave empty to allow any address. Example: 203.0.113.0/24',
  'apiAccess.keyForm.addressesTooMany': 'Enter at most {max} addresses',
  'apiAccess.keyForm.expiry': 'Stops working',
  'apiAccess.keyForm.expiryHint': 'A key that expires is safer: if it gets lost, it stops working by itself.',
  'apiAccess.keyForm.expiry.d30': 'After 30 days',
  'apiAccess.keyForm.expiry.d90': 'After 90 days',
  'apiAccess.keyForm.expiry.y1': 'After 1 year',
  'apiAccess.keyForm.expiry.never': 'Never',
  'apiAccess.keyForm.create': 'Create key',
  'apiAccess.keyForm.created': 'Key created',

  'apiAccess.secret.keyTitle': 'Copy your key now',
  'apiAccess.secret.keyWarning': 'Bulk shows this key only once and keeps no readable copy. If you lose it, revoke it and make a new one.',
  'apiAccess.secret.keyLabel': 'Your API key',
  'apiAccess.secret.signingTitle': 'Copy the signing secret now',
  'apiAccess.secret.signingWarning': 'Bulk shows this secret only once. If you lose it, replace it with a new one.',
  'apiAccess.secret.signingHint': 'The receiving service checks the X-Bulk-Signature header of every delivery against this secret.',
  'apiAccess.secret.signingLabel': 'Signing secret',
  'apiAccess.secret.done': 'I have copied it',

  'apiAccess.hooks.title': 'Webhooks',
  'apiAccess.hooks.description': 'Bulk sends a signed POST request to your address when the events you choose happen.',
  'apiAccess.hooks.add': 'Add endpoint',
  'apiAccess.hooks.empty': 'No webhook endpoints yet',
  'apiAccess.hooks.emptyHint': 'Add an address to be told when a member joins, a payment arrives or someone enters the gym.',
  'apiAccess.hooks.url': 'Address',
  'apiAccess.hooks.events': 'Events',
  'apiAccess.hooks.state': 'State',
  'apiAccess.hooks.lastSuccess': 'Last success',
  'apiAccess.hooks.noSuccess': 'None yet',
  'apiAccess.hooks.on': 'On',
  'apiAccess.hooks.off': 'Off',
  'apiAccess.hooks.autoOff': 'Switched off after failing',
  'apiAccess.hooks.failingSince': 'Failing since {date}',
  'apiAccess.hooks.failures.one': '{count} failure in a row',
  'apiAccess.hooks.failures.other': '{count} failures in a row',
  'apiAccess.hooks.switchOn': 'Switch on',
  'apiAccess.hooks.switchOff': 'Switch off',
  'apiAccess.hooks.switchedOn': 'Endpoint switched on',
  'apiAccess.hooks.switchedOff': 'Endpoint switched off',
  'apiAccess.hooks.test': 'Send test event',
  'apiAccess.hooks.testOff': 'Switch the endpoint on to send it a test event',
  'apiAccess.hooks.testSent': 'Test event sent. See the result under Deliveries.',
  'apiAccess.hooks.rotate': 'Replace secret',
  'apiAccess.hooks.rotateTitle': 'Replace the signing secret?',
  'apiAccess.hooks.rotateHint': 'Bulk makes a new signing secret and shows it once. The receiving service has to switch to it.',
  'apiAccess.hooks.rotateOverlap': 'Keep the old secret working for 24 hours',
  'apiAccess.hooks.rotateOverlapHint': 'Every delivery carries a second signature made with the old secret, so the receiving service keeps accepting them while you switch over.',
  'apiAccess.hooks.rotateNow': 'The old secret stops working at once, and the receiving service rejects deliveries until it has the new one. Use this when the old secret leaked.',
  'apiAccess.hooks.rotated': 'Signing secret replaced',
  'apiAccess.hooks.previousSecretUntil': 'Old secret still signs until {date}',
  'apiAccess.hooks.deliveries': 'Deliveries',
  'apiAccess.hooks.deleteTitle': 'Delete this endpoint?',
  'apiAccess.hooks.deleteHint': 'Bulk stops sending to {url} and its delivery history is removed. This cannot be undone.',
  'apiAccess.hooks.deleted': 'Endpoint deleted',

  'apiAccess.hookForm.addTitle': 'Add a webhook endpoint',
  'apiAccess.hookForm.editTitle': 'Edit the endpoint',
  'apiAccess.hookForm.description': 'Bulk sends each chosen event to this address as a signed POST request.',
  'apiAccess.hookForm.urlPlaceholder': 'https://example.com/bulk-events',
  'apiAccess.hookForm.urlHint': 'An https address on the public internet. Bulk checks it when you save.',
  'apiAccess.hookForm.urlRequired': 'Enter the address',
  'apiAccess.hookForm.descriptionLabel': 'Description',
  'apiAccess.hookForm.descriptionPlaceholder': 'Accounting software',
  'apiAccess.hookForm.events': 'Events to send',
  'apiAccess.hookForm.eventsRequired': 'Choose at least one event',
  'apiAccess.hookForm.created': 'Endpoint added',
  'apiAccess.hookForm.saved': 'Endpoint saved',

  'apiAccess.deliveries.title': 'Deliveries',
  'apiAccess.deliveries.filter': 'Show',
  'apiAccess.deliveries.all': 'All deliveries',
  'apiAccess.deliveries.empty': 'Nothing sent yet',
  'apiAccess.deliveries.emptyHint': 'Deliveries appear here when one of the chosen events happens.',
  'apiAccess.deliveries.when': 'When',
  'apiAccess.deliveries.event': 'Event',
  'apiAccess.deliveries.attempts': 'Attempts',
  'apiAccess.deliveries.answer': 'Answer',
  'apiAccess.deliveries.httpStatus': 'HTTP {status}',
  'apiAccess.deliveries.nextAttempt': 'Next try {date}',
  'apiAccess.deliveries.details': 'Details',
  'apiAccess.deliveries.hideDetails': 'Hide',
  'apiAccess.deliveries.payload': 'Sent data',
  'apiAccess.deliveries.responseBody': 'Start of the receiver’s answer',
  'apiAccess.deliveries.noResponseBody': 'The receiver sent no text back.',
  'apiAccess.deliveries.resend': 'Resend',
  'apiAccess.deliveries.resent': 'Queued to be sent again',

  'admin.apiError.API_KEY_EXPIRY_PAST': 'The expiry date has already passed. Choose a later one.',
  'admin.apiError.API_KEY_LIMIT': 'A gym can have at most {max} API keys at a time. Revoke one you no longer use first.',
  'admin.apiError.PRACTICE_GYM_NO_API': 'A practice gym has no API access. Use your real gym for keys and webhooks.',
  'admin.apiError.WEBHOOK_URL_NOT_HTTPS': 'The address must start with https://.',
  'admin.apiError.WEBHOOK_URL_INVALID': 'That is not a valid web address.',
  'admin.apiError.WEBHOOK_URL_PRIVATE': 'The address must be on the public internet. Private, local and link-local addresses are refused, including names that point to one.',
  'admin.apiError.WEBHOOK_URL_UNRESOLVABLE': 'Bulk could not find that address. Check the spelling of the domain.',
  'admin.apiError.WEBHOOK_ENDPOINT_LIMIT': 'A gym can have at most {max} webhook endpoints. Delete one you no longer use first.',
  'admin.apiError.WEBHOOK_ENDPOINT_DISABLED': 'Switch the endpoint on first. A switched-off endpoint is sent nothing, not even a test.',
};

export const ka: Record<keyof typeof en, string> = {
  'enum.apiKeyScope.members:read': 'წევრები',
  'enum.apiKeyScope.payments:read': 'გადახდები',
  'enum.apiKeyScope.visits:read': 'ვიზიტები',
  'enum.apiKeyScope.classes:read': 'ვარჯიშები',

  'enum.apiKeyStatus.ACTIVE': 'აქტიური',
  'enum.apiKeyStatus.EXPIRED': 'ვადაგასული',
  'enum.apiKeyStatus.REVOKED': 'გაუქმებული',

  'enum.webhookEvent.member.created': 'ახალი წევრი',
  'enum.webhookEvent.membership.activated': 'აბონემენტი გააქტიურდა',
  'enum.webhookEvent.membership.expired': 'აბონემენტის ვადა გავიდა',
  'enum.webhookEvent.payment.succeeded': 'გადახდა მიღებულია',
  'enum.webhookEvent.payment.refunded': 'თანხა დაბრუნდა',
  'enum.webhookEvent.visit.recorded': 'ვიზიტი დაფიქსირდა',
  'enum.webhookEvent.ping': 'სატესტო მოვლენა',

  'enum.webhookDeliveryStatus.PENDING': 'ელოდება',
  'enum.webhookDeliveryStatus.SUCCEEDED': 'მიტანილია',
  'enum.webhookDeliveryStatus.FAILED': 'ვერ მიიტანა',
  'enum.webhookDeliveryStatus.SKIPPED': 'გამოტოვებულია',

  'enum.webhookDeliveryError.TIMEOUT': 'პასუხი დროულად არ მოვიდა',
  'enum.webhookDeliveryError.CONNECTION_FAILED': 'დაკავშირება ვერ მოხერხდა',
  'enum.webhookDeliveryError.TLS_FAILED': 'დაცული კავშირი ვერ დამყარდა',
  'enum.webhookDeliveryError.PRIVATE_ADDRESS': 'მისამართი საჯარო არ არის',
  'enum.webhookDeliveryError.UNRESOLVABLE': 'მისამართი ვერ მოიძებნა',
  'enum.webhookDeliveryError.INVALID_URL': 'მისამართი არასწორია',
  'enum.webhookDeliveryError.ENDPOINT_DISABLED': 'მისამართი გამორთული იყო',
  'enum.webhookDeliveryError.SECRET_UNREADABLE': 'Bulk-მა ხელმოწერის საიდუმლო ვერ წაიკითხა; არაფერი გაიგზავნა',

  'apiAccess.keys.title': 'API გასაღებები',
  'apiAccess.keys.description': 'მხოლოდ წასაკითხი გასაღებები თქვენი საკუთარი ხელსაწყოებისთვის, მაგალითად ბუღალტრის პროგრამისთვის ან მისაღების ეკრანისთვის. გასაღებით Bulk-ში ვერაფერს შეცვლით.',
  'apiAccess.keys.baseUrl': 'მისამართი, რომელსაც თქვენი ხელსაწყოები მიმართავენ',
  'apiAccess.keys.baseUrlHint': 'გასაღები გადაეცით Authorization: Bearer … სათაურში. ის მხოლოდ ამ დარბაზის მისამართზე მუშაობს. აღწერა იხილეთ აქ: {docs}.',
  'apiAccess.keys.new': 'ახალი გასაღები',
  'apiAccess.keys.empty': 'API გასაღებები ჯერ არ არის',
  'apiAccess.keys.emptyHint': 'შექმენით გასაღები, როცა თქვენს ხელსაწყოს წევრების, გადახდების, ვიზიტების ან ვარჯიშების წაკითხვა დასჭირდება.',
  'apiAccess.keys.key': 'გასაღები',
  'apiAccess.keys.reads': 'წაკითხვა შეუძლია',
  'apiAccess.keys.allowedFrom': 'ნებადართული მისამართები',
  'apiAccess.keys.anyAddress': 'ნებისმიერი მისამართი',
  'apiAccess.keys.lastUsed': 'ბოლოს გამოყენებული',
  'apiAccess.keys.expires': 'ვადა',
  'apiAccess.keys.createdBy': 'შექმნა',
  'apiAccess.keys.revoke': 'გაუქმება',
  'apiAccess.keys.revokeNamed': 'გასაღების „{name}“ გაუქმება',
  'apiAccess.keys.revokeTitle': 'გავაუქმოთ „{name}“?',
  'apiAccess.keys.revokeHint': 'ამ გასაღებით მომუშავე ყველა ხელსაწყო მაშინვე შეწყვეტს მუშაობას. ამის გაუქმება შეუძლებელია; თუ ისევ დაგჭირდებათ, შექმენით ახალი გასაღები.',
  'apiAccess.keys.revoked': 'გასაღები გაუქმებულია',

  'apiAccess.keyForm.title': 'ახალი API გასაღები',
  'apiAccess.keyForm.description': 'გასაღები მხოლოდ კითხულობს. აირჩიეთ, რისი წაკითხვა შეუძლია, რომელი მისამართებიდან შეიძლება მისი გამოყენება და როდემდე მუშაობს.',
  'apiAccess.keyForm.namePlaceholder': 'ბუღალტრის ექსპორტი',
  'apiAccess.keyForm.nameHint': 'რისთვის არის გასაღები, რომ მოგვიანებით გასაღებები ერთმანეთისგან განასხვაოთ.',
  'apiAccess.keyForm.nameRequired': 'დაარქვით გასაღებს სახელი',
  'apiAccess.keyForm.scopes': 'რისი წაკითხვა შეუძლია',
  'apiAccess.keyForm.scopesRequired': 'აირჩიეთ მინიმუმ ერთი',
  'apiAccess.keyForm.scopeHint.members': 'სახელები, წევრის ნომრები, საკონტაქტო მონაცემები და სტატუსი.',
  'apiAccess.keyForm.scopeHint.payments': 'გადახდები და თანხის დაბრუნებები.',
  'apiAccess.keyForm.scopeHint.visits': 'შესვლები კარიბჭეებზე და მისაღებში.',
  'apiAccess.keyForm.scopeHint.classes': 'ვარჯიშები და მათი დაგეგმილი სესიები.',
  'apiAccess.keyForm.addresses': 'ნებადართული მისამართები',
  'apiAccess.keyForm.addressesHint': 'თითო ხაზზე ერთი ან მძიმით გამოყოფილი. თუ ცარიელია, გასაღები ნებისმიერი მისამართიდან იმუშავებს. მაგალითი: 203.0.113.0/24',
  'apiAccess.keyForm.addressesTooMany': 'მიუთითეთ მაქსიმუმ {max} მისამართი',
  'apiAccess.keyForm.expiry': 'მოქმედების ვადა',
  'apiAccess.keyForm.expiryHint': 'ვადიანი გასაღები უფრო უსაფრთხოა: თუ დაიკარგა, თავისით შეწყვეტს მუშაობას.',
  'apiAccess.keyForm.expiry.d30': '30 დღის შემდეგ',
  'apiAccess.keyForm.expiry.d90': '90 დღის შემდეგ',
  'apiAccess.keyForm.expiry.y1': '1 წლის შემდეგ',
  'apiAccess.keyForm.expiry.never': 'უვადო',
  'apiAccess.keyForm.create': 'გასაღების შექმნა',
  'apiAccess.keyForm.created': 'გასაღები შექმნილია',

  'apiAccess.secret.keyTitle': 'დააკოპირეთ გასაღები ახლავე',
  'apiAccess.secret.keyWarning': 'Bulk ამ გასაღებს მხოლოდ ერთხელ აჩვენებს და მის წასაკითხ ასლს არ ინახავს. თუ დაკარგავთ, გააუქმეთ და შექმენით ახალი.',
  'apiAccess.secret.keyLabel': 'თქვენი API გასაღები',
  'apiAccess.secret.signingTitle': 'დააკოპირეთ ხელმოწერის საიდუმლო ახლავე',
  'apiAccess.secret.signingWarning': 'Bulk ამ საიდუმლოს მხოლოდ ერთხელ აჩვენებს. თუ დაკარგავთ, შეცვალეთ ახლით.',
  'apiAccess.secret.signingHint': 'მიმღები სერვისი ამ საიდუმლოთი ამოწმებს თითოეული გაგზავნის X-Bulk-Signature სათაურს.',
  'apiAccess.secret.signingLabel': 'ხელმოწერის საიდუმლო',
  'apiAccess.secret.done': 'დავაკოპირე',

  'apiAccess.hooks.title': 'ვებჰუკები',
  'apiAccess.hooks.description': 'არჩეული მოვლენების დადგომისას Bulk თქვენს მისამართზე ხელმოწერილ POST მოთხოვნას აგზავნის.',
  'apiAccess.hooks.add': 'მისამართის დამატება',
  'apiAccess.hooks.empty': 'ვებჰუკის მისამართები ჯერ არ არის',
  'apiAccess.hooks.emptyHint': 'დაამატეთ მისამართი, რომ გაიგოთ, როდის დარეგისტრირდა ახალი წევრი, როდის მოვიდა გადახდა ან ვინ შემოვიდა დარბაზში.',
  'apiAccess.hooks.url': 'მისამართი',
  'apiAccess.hooks.events': 'მოვლენები',
  'apiAccess.hooks.state': 'მდგომარეობა',
  'apiAccess.hooks.lastSuccess': 'ბოლო წარმატებული გაგზავნა',
  'apiAccess.hooks.noSuccess': 'ჯერ არ ყოფილა',
  'apiAccess.hooks.on': 'ჩართულია',
  'apiAccess.hooks.off': 'გამორთულია',
  'apiAccess.hooks.autoOff': 'გამორთულია შეცდომების გამო',
  'apiAccess.hooks.failingSince': 'შეცდომები დაიწყო: {date}',
  'apiAccess.hooks.failures.one': '{count} შეცდომა ზედიზედ',
  'apiAccess.hooks.failures.other': '{count} შეცდომა ზედიზედ',
  'apiAccess.hooks.switchOn': 'ჩართვა',
  'apiAccess.hooks.switchOff': 'გამორთვა',
  'apiAccess.hooks.switchedOn': 'მისამართი ჩართულია',
  'apiAccess.hooks.switchedOff': 'მისამართი გამორთულია',
  'apiAccess.hooks.test': 'სატესტო მოვლენის გაგზავნა',
  'apiAccess.hooks.testOff': 'სატესტო მოვლენის გასაგზავნად ჯერ ჩართეთ მისამართი',
  'apiAccess.hooks.testSent': 'სატესტო მოვლენა გაიგზავნა. შედეგი იხილეთ „გაგზავნებში“.',
  'apiAccess.hooks.rotate': 'საიდუმლოს შეცვლა',
  'apiAccess.hooks.rotateTitle': 'შევცვალოთ ხელმოწერის საიდუმლო?',
  'apiAccess.hooks.rotateHint': 'Bulk შექმნის ხელმოწერის ახალ საიდუმლოს და მხოლოდ ერთხელ აჩვენებს. მიმღებ სერვისს მასზე გადასვლა დასჭირდება.',
  'apiAccess.hooks.rotateOverlap': 'ძველი საიდუმლო კიდევ 24 საათით დარჩეს მოქმედი',
  'apiAccess.hooks.rotateOverlapHint': 'თითოეულ გაგზავნას ძველი საიდუმლოთი შექმნილი მეორე ხელმოწერაც ახლავს, ამიტომ მიმღები სერვისი მათ მიიღებს, სანამ ახალზე გადახვალთ.',
  'apiAccess.hooks.rotateNow': 'ძველი საიდუმლო მაშინვე შეწყვეტს მოქმედებას და მიმღები სერვისი გაგზავნებს უარყოფს, სანამ ახალს არ მიიღებს. გამოიყენეთ, როცა ძველი საიდუმლო გაჟონილია.',
  'apiAccess.hooks.rotated': 'ხელმოწერის საიდუმლო შეიცვალა',
  'apiAccess.hooks.previousSecretUntil': 'ძველი საიდუმლო კვლავ მოქმედებს, ვადა: {date}',
  'apiAccess.hooks.deliveries': 'გაგზავნები',
  'apiAccess.hooks.deleteTitle': 'წავშალოთ ეს მისამართი?',
  'apiAccess.hooks.deleteHint': 'Bulk შეწყვეტს გაგზავნას მისამართზე {url} და მისი გაგზავნების ისტორია წაიშლება. ამის გაუქმება შეუძლებელია.',
  'apiAccess.hooks.deleted': 'მისამართი წაიშალა',

  'apiAccess.hookForm.addTitle': 'ვებჰუკის მისამართის დამატება',
  'apiAccess.hookForm.editTitle': 'მისამართის რედაქტირება',
  'apiAccess.hookForm.description': 'Bulk თითოეულ არჩეულ მოვლენას ამ მისამართზე ხელმოწერილი POST მოთხოვნით გააგზავნის.',
  'apiAccess.hookForm.urlPlaceholder': 'https://example.com/bulk-events',
  'apiAccess.hookForm.urlHint': 'https მისამართი საჯარო ინტერნეტში. Bulk მას შენახვისას შეამოწმებს.',
  'apiAccess.hookForm.urlRequired': 'მიუთითეთ მისამართი',
  'apiAccess.hookForm.descriptionLabel': 'აღწერა',
  'apiAccess.hookForm.descriptionPlaceholder': 'ბუღალტრული პროგრამა',
  'apiAccess.hookForm.events': 'გასაგზავნი მოვლენები',
  'apiAccess.hookForm.eventsRequired': 'აირჩიეთ მინიმუმ ერთი მოვლენა',
  'apiAccess.hookForm.created': 'მისამართი დამატებულია',
  'apiAccess.hookForm.saved': 'მისამართი შენახულია',

  'apiAccess.deliveries.title': 'გაგზავნები',
  'apiAccess.deliveries.filter': 'ჩვენება',
  'apiAccess.deliveries.all': 'ყველა გაგზავნა',
  'apiAccess.deliveries.empty': 'ჯერ არაფერი გაგზავნილა',
  'apiAccess.deliveries.emptyHint': 'გაგზავნები აქ გამოჩნდება, როცა არჩეული მოვლენებიდან რომელიმე მოხდება.',
  'apiAccess.deliveries.when': 'დრო',
  'apiAccess.deliveries.event': 'მოვლენა',
  'apiAccess.deliveries.attempts': 'მცდელობები',
  'apiAccess.deliveries.answer': 'პასუხი',
  'apiAccess.deliveries.httpStatus': 'HTTP {status}',
  'apiAccess.deliveries.nextAttempt': 'შემდეგი მცდელობა: {date}',
  'apiAccess.deliveries.details': 'დეტალები',
  'apiAccess.deliveries.hideDetails': 'დამალვა',
  'apiAccess.deliveries.payload': 'გაგზავნილი მონაცემები',
  'apiAccess.deliveries.responseBody': 'მიმღების პასუხის დასაწყისი',
  'apiAccess.deliveries.noResponseBody': 'მიმღებს ტექსტი არ დაუბრუნებია.',
  'apiAccess.deliveries.resend': 'ხელახლა გაგზავნა',
  'apiAccess.deliveries.resent': 'ხელახლა გასაგზავნად დაგეგმილია',

  'admin.apiError.API_KEY_EXPIRY_PAST': 'ვადის თარიღი უკვე გასულია. აირჩიეთ უფრო გვიანდელი.',
  'admin.apiError.API_KEY_LIMIT': 'დარბაზს ერთდროულად მაქსიმუმ {max} API გასაღები შეიძლება ჰქონდეს. ჯერ გააუქმეთ ის, რომელსაც აღარ იყენებთ.',
  'admin.apiError.PRACTICE_GYM_NO_API': 'სავარჯიშო დარბაზს API წვდომა არ აქვს. გასაღებებისა და ვებჰუკებისთვის გამოიყენეთ თქვენი რეალური დარბაზი.',
  'admin.apiError.WEBHOOK_URL_NOT_HTTPS': 'მისამართი https://-ით უნდა იწყებოდეს.',
  'admin.apiError.WEBHOOK_URL_INVALID': 'ეს ვებმისამართი არასწორია.',
  'admin.apiError.WEBHOOK_URL_PRIVATE': 'მისამართი საჯარო ინტერნეტში უნდა იყოს. კერძო, ლოკალური და შიდა ქსელის მისამართები უარყოფილია, მათზე მიმთითებელი სახელებიც.',
  'admin.apiError.WEBHOOK_URL_UNRESOLVABLE': 'Bulk-მა ეს მისამართი ვერ იპოვა. შეამოწმეთ დომენის სახელი.',
  'admin.apiError.WEBHOOK_ENDPOINT_LIMIT': 'დარბაზს მაქსიმუმ {max} ვებჰუკის მისამართი შეიძლება ჰქონდეს. ჯერ წაშალეთ ის, რომელსაც აღარ იყენებთ.',
  'admin.apiError.WEBHOOK_ENDPOINT_DISABLED': 'ჯერ ჩართეთ მისამართი. გამორთულ მისამართზე არაფერი იგზავნება, სატესტო მოვლენაც კი.',
};
